import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=454bbbca&"
import script from "./Signature.vue?vue&type=script&lang=js&"
export * from "./Signature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports